import { Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { SystemEvent } from '../../events';

@Injectable({
  providedIn: 'root'
})
export class SystemEventsService implements OnDestroy {
  private systemEventReceived$: ReplaySubject<SystemEvent> = new ReplaySubject<SystemEvent>(1);

  constructor() {}

  ngOnDestroy() {
    this.systemEventReceived$.complete();
  }

  getSystemEvents(): Observable<SystemEvent> {
    return this.systemEventReceived$.asObservable();
  }

  sendSystemEvent(systemUpdateEvent: SystemEvent) {
    return this.systemEventReceived$.next(systemUpdateEvent);
  }
}
